import { AuthStatus } from '@caresend/types';
import { computed } from 'vue';
import '@caresend/utils';
import 'lodash.isequal';
import { getRoute } from '../../../router/helpers/initRouter.js';
import { getStore } from '../../../store/helpers/initStore.js';
import { useUserRole } from '../../../composables/user.js';
import 'immutability-helper';
import '../../../router/routes/dev/model.js';
import '../../../router/routes/dev/routes.js';
import { homeRoute } from '../../../router/routes/locations.js';
import '../../../router/routes/orderFlow/model.js';
import '../../../router/routes/orderFlow/privateHelpers.js';
import '../../../router/routes/orderFlow/routes.js';
import { SchedulingFlowRouteName } from '../../../router/routes/schedulingFlow/model.js';
import '../../../router/routes/schedulingFlow/routes.js';
import '../../../router/routes/chartingFlow/model.js';
import '../../../router/routes/chartingFlow/routes.js';
import '../../../router/routes/portal/portalRoutes.js';
import '../../../router/routes/portal/model.js';
import '../../../router/routes/pro/model.js';
import '../../../router/routes/visitsPage/model.js';
import '../../../router/routes/visitsPage/routes.js';
import '../../specific/portal/store/portal/sessionStore.js';
import 'file-saver';
import '../../../database/firebaseConfig/cloudFunctions.js';
import '../../../database/encryption/model.js';
import 'js-sha256';
import 'lodash.clonedeep';
import '../../specific/portal/store/storeUtilities/dbSync/dbSyncStore.js';
import '../../../store/modules/app/model.js';
import 'firebase/database';
import 'firebase/auth';
import '../../../database/firebaseConfig/init.js';
import '../../../database/firebaseConfig/methods.js';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../ui/Icon.vue.js';
import '../../../functions/configuration/icons.js';
import '../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../functions/tracking/index.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import '../../specific/dev/AdvancedSettings/subViews/FeatureFlags/model.js';
import '../../../store/modules/auth/index.js';
import 'dayjs';
import '../../../store/pinia/draftWaypoints/index.js';
import '../../../store/modules/chartingFlow/chartingFlowSteps/steps.js';
import '../../../store/modules/chartingFlow/model.js';
import '../../../store/modules/office/index.js';
import '../../specific/VisitsPage/subComponents/OrdersVisitsFilters/model.js';
import '../../../store/modules/office/model.js';
import '../../../store/modules/orderFlow/index.js';
import '../../../store/modules/procedures/model.js';
import '../../../store/modules/schedulingFlow/index.js';
import '../../../store/modules/schedulingFlow/model.js';

const useSharedNavBarLogic = () => {
    const store = getStore();
    const route = getRoute();
    const userRole = useUserRole();
    const isLoggedIn = computed(() => store.state.auth.authStatus !== AuthStatus.SIGNED_OUT);
    const isPatientSchedulingFlow = computed(() => userRole.isPatient.value
        && !!route.value.name
        && Object.values(SchedulingFlowRouteName).includes(route.value.name));
    const hideNavItems = computed(() => isPatientSchedulingFlow.value);
    const hideSignUpButton = computed(() => { var _a; return !!((_a = route.value.meta) === null || _a === void 0 ? void 0 : _a.hideSignUpButton); });
    const hideSignInButton = computed(() => { var _a; return !!((_a = route.value.meta) === null || _a === void 0 ? void 0 : _a.hideSignInButton); });
    const menuInfo = computed(() => store.getters['app/getMenuInfo']);
    // Delay loading of desktop menu until menu info is loaded
    const desktopMenuReady = computed(() => isLoggedIn.value && !!menuInfo.value);
    return {
        desktopMenuReady,
        hideNavItems,
        hideSignInButton,
        hideSignUpButton,
        homeRoute,
        isLoggedIn,
    };
};

export { useSharedNavBarLogic };
